


export const TrailerData=(payload)=>{
    // console.log(payload)
    return{
        type:"TRAILER_DATA",
        payload
    }
}

export const TrailerDetails=(payload)=>{
    return{
        type:"TRAILER_DETAILS",
        payload
    }
}